package com.milta.core.localization

data class SubscriptionExpiredStrings(
    val title: String,
    val driverSoloMessage: String,
    val patronMessage: String,
    val driverUnderPatronMessage: String,
    val renewButton: String,
    val close: String,
    // Full-screen non-dismissible blocker (trial/subscription expired) — "Se déconnecter" and
    // "Supprimer mon compte" reuse strings.profile.signOut / strings.profile.deleteAccount instead
    // of duplicating that copy here.
    /** Contains a "%s" placeholder replaced by the formatted price (e.g. "7.99 €/mois"). */
    val subscribeButtonTemplate: String,
    // Driver blocked on their own subscription (scope OWN): their link code is shown so they can
    // hand it to an Enterprise, whose subscription then covers them. The code row reuses
    // strings.profile.linkedCodeLabel / copyCode / codeCopied / linkedCodeLoadError.
    val driverLinkCodeHint: String,
    // "Vérifier mon accès": re-checks the access without restarting the app (secondary button,
    // above "Se déconnecter"); the short message when access is still refused.
    val checkAccessButton: String,
    val accessStillUnavailable: String,
)
